
import { forkJoin as observableForkJoin, Observable } from 'rxjs';
import { NewHtmlFlags } from './../../models/MTemplateDataResource';
import { NewsletterResource } from './../../models/NewsletterResource';
import { Component, OnInit, EventEmitter, Output, Input, ElementRef } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { AddNewsletterService } from "app/newsletter/add-newsletter/add-newsletter.service";
import { MTemplateDataResource } from "app/models/MTemplateDataResource";
import { ContentTextResource, NewTopicHtmlFlags } from "app/models/ContentTextResource";
import { NotificationsService } from "angular2-notifications";
import { TextContentService } from 'app/text-content/text-content.service';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TagResource } from "app/models/TagResource";
import { ContentCommonFileResource } from 'app/models/ContentCommonFileResource';
import { MTemplateDataFileListResource } from 'app/models/MTemplateDataFileListResource';
import { UtilsService } from 'app/services/utils.service';

@Component({
	selector: 'vbn-add-newsletter',
	providers: [AddNewsletterService],
	templateUrl: './add-newsletter.component.html',
	styleUrls: ['./add-newsletter.component.scss'],
})
export class AddNewsletterComponent implements OnInit {

	addressParams: any;
	errorMessage: string;
	templateDataResource: MTemplateDataResource;
	// inputCategories: boolean = false;
	inputMosaico: boolean = false;
	//isTemplateCreated: string = localStorage.getItem('templateCreatedAdd');
	hasTemplate: boolean = false;
	isEditeMode: boolean = false;
	safeHtml: SafeHtml;
	noneSelected: boolean = true;
	showSuccessAlert = true;
	private timer;
	private succesAddNewsletter;
	selected_language: string = "ro"
	noneTagsSelected: boolean = true;
	checkTagsRO: any;
	checkTagsEN: any;
	checkTagsDE: any;
	checkObject: any;
	saveErrors;
	checked: boolean;
	tagList: TagResource[];
	tagListResource: TagResource[];

	tagListRO: TagResource[];
	tagListEN: TagResource[];
	tagListDE: TagResource[];
	tagListResourceRO: TagResource[];
	tagListResourceEN: TagResource[];
	tagListResourceDE: TagResource[];
	currentLanguage = localStorage.getItem("vbn-language");
	errorTags: boolean = false;

	files: any = [];
	documentList: MTemplateDataFileListResource;
	emptyArray: MTemplateDataFileListResource;
	formDataDoc: FormData;
	showDocuments: boolean;
	showConfirmation: boolean;
	userEmail: string;


	constructor(private translate: TranslateService,
		private addNewsletterService: AddNewsletterService,
		private element: ElementRef,
		private _notificationService: NotificationsService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public sanitizer: DomSanitizer,
		private service: UtilsService) {
		this.templateDataResource = new MTemplateDataResource();
		this.templateDataResource.newHtmlFlags = new NewHtmlFlags();
		this.succesAddNewsletter = false;
		this.emptyArray = new MTemplateDataFileListResource();
		this.emptyArray.mTemplateDataFileList = [];
		this.showConfirmation = false;

		// if (this.isTemplateCreated === "true") {
		// 	var id = localStorage.getItem('templateIdAdd');
		// 	this.getNewsletterTemplate(id);
		// 	console.log('id template creat = ', id);
		// }	
		//this.tagList = new Array();
		//this.tagListResource = new Array();
		//this.templateDataResource.tags = new Array();
		// this.checkTagsRO = new Array();
		// this.checkTagsEN = new Array();
		// this.checkTagsDE = new Array();

		// this.tagListRO = new Array();
		// this.tagListEN = new Array();
		// this.tagListDE = new Array();
		// this.tagListResourceRO = new Array();
		// this.tagListResourceEN = new Array();
		// this.tagListResourceDE = new Array();
	}

	ngOnInit() {
		this.userEmail = this.service.currentUserEmail;
		if (this.router.url != "/add-newsletter") {
			this.isEditeMode = true;
			this.activatedRoute.params.subscribe((params: Params) => {
				this.addressParams = JSON.parse(atob(params['json']));
				console.log("Adressparam", this.addressParams);
				this.safeHtml = this.sanitizer.bypassSecurityTrustResourceUrl("/image/templateHtml/" + this.addressParams.newsletterRid);
			});
			this.getNewsletterTemplate(this.addressParams.newsletterRid)
			this.getDocuments();
		} else {
			this.isEditeMode = false;
		}
		//this.getAllActiveTagsRO('ro');
		//this.getAllActiveTagsEN('en');
		//this.getAllActiveTagsDE('de');
	}

	getAllActiveTagsEN(language) {
		this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
			this.currentLanguage = localStorage.getItem("vbn-language");
		});
		this.tagListEN = new Array<TagResource>();
		this.addNewsletterService.getAllTags('/admin/tags/getAllActive?language=' + language)
			.subscribe(
				response => {
					//this.tagListResource = response;
					this.tagListEN = response.tagListResource;
					if (!this.isEditeMode) {
						if (response.tagListResource == null) {
							this.tagListResourceEN = []
						} else {
							this.tagListResourceEN = response.tagListResource;
						}
						this.checkTagsEN = [];
						for (let i = 0; i < this.tagListResourceEN.length; i++) {
							this.checkObject = {};
							this.checkObject.check = false;
							this.checkObject.rid = this.tagListResourceEN[i].rid;
							this.checkTagsEN.push(this.checkObject)
						}
						this.checkObject = {};
					} else {
						this.getNewsletterTemplate(this.addressParams.newsletterRid)
					}
				},
				error => this.errorMessage = <any>error
			);
	}

	getAllActiveTagsRO(language) {
		this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
			this.currentLanguage = localStorage.getItem("vbn-language");
		});
		this.tagListRO = new Array<TagResource>();
		this.addNewsletterService.getAllTags('/admin/tags/getAllActive?language=' + language)
			.subscribe(
				response => {
					//this.tagListResource = response;
					this.tagListRO = response.tagListResource;
					if (!this.isEditeMode) {
						if (response.tagListResource == null) {
							this.tagListResourceRO = []
						} else {
							this.tagListResourceRO = response.tagListResource;
						}
						this.checkTagsRO = [];
						for (let i = 0; i < this.tagListResourceRO.length; i++) {
							this.checkObject = {};
							this.checkObject.check = false;
							this.checkObject.rid = this.tagListResourceRO[i].rid;
							this.checkTagsRO.push(this.checkObject)
						}
						this.checkObject = {};
					} else {
						this.getNewsletterTemplate(this.addressParams.newsletterRid)
					}
				},
				error => this.errorMessage = <any>error
			);
	}

	getAllActiveTagsDE(language) {
		this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
			this.currentLanguage = localStorage.getItem("vbn-language");
		});
		this.tagListDE = new Array<TagResource>();
		this.addNewsletterService.getAllTags('/admin/tags/getAllActive?language=' + language)
			.subscribe(
				response => {
					//this.tagListResource = response;
					this.tagListDE = response.tagListResource;
					if (!this.isEditeMode) {
						if (response.tagListResource == null) {
							this.tagListResourceDE = []
						} else {
							this.tagListResourceDE = response.tagListResource;
						}
						this.checkTagsDE = [];
						for (let i = 0; i < this.tagListResourceDE.length; i++) {
							this.checkObject = {};
							this.checkObject.check = false;
							this.checkObject.rid = this.tagListResourceDE[i].rid;
							this.checkTagsDE.push(this.checkObject)
						}
						this.checkObject = {};
					} else {
						this.getNewsletterTemplate(this.addressParams.newsletterRid)
					}
				},
				error => this.errorMessage = <any>error
			);
	}

	back() {
		this.router.navigateByUrl('/newsletter-list');
	}

	// getNewsletterTemplate(templateId) {
	// 	this.addNewsletterService.getNewsletterTemplate(templateId)
	// 		.subscribe(
	// 		response => {
	// 			console.log('success.GET newsletter template --->:', response);
	// 			this.templateDataResource = response;
	// 			this.templateDataResource.newHtmlFlags = new NewHtmlFlags();
	// 			if (this.templateDataResource.path != null) {
	// 				this.hasTemplate = true;
	// 			} else {
	// 				this.hasTemplate = false;
	// 			}
	// 			// if (this.templateDataResource.cinema == true && this.templateDataResource.news == true) {
	// 			// 	this.noneSelected = false;
	// 			// }
	// 			if(this.templateDataResource.news == true){
	// 				this.noneSelected = false;
	// 			}
	// 		},
	// 		error => this.errorMessage = <any>error);
	// }

	getNewsletterTemplate(templateId) {
		this.addNewsletterService.getNewsletterTemplate('/templateEditor/get/' + templateId)
			.subscribe(
				response => {
					console.log('success.GET newsletter template --->:', response);
					this.templateDataResource = response;
					this.templateDataResource.newHtmlFlags = new NewHtmlFlags();
					if (this.templateDataResource.path != null) {
						this.hasTemplate = true;
					} else {
						this.hasTemplate = false;
					}
					// this.tagListResourceRO = this.tagListRO;
					// for (let i = 0; i < this.tagListResourceRO.length; i++) {
					// 	let checkObject: any = {};
					// 	checkObject.check = false;
					// 	checkObject.rid = this.tagListResourceRO[i].rid;

					// 	let foundObj = this.templateDataResource.tags.find(s => s.rid == checkObject.rid);
					// 	if (foundObj != null)
					// 		checkObject.check = true;
					// 	this.checkTagsRO.push(checkObject)
					// }

					// this.tagListResourceEN = this.tagListEN;
					// for (let i = 0; i < this.tagListResourceEN.length; i++) {
					// 	let checkObject: any = {};
					// 	checkObject.check = false;
					// 	checkObject.rid = this.tagListResourceEN[i].rid;

					// 	let foundObj = this.templateDataResource.tags.find(s => s.rid == checkObject.rid);
					// 	if (foundObj != null)
					// 		checkObject.check = true;
					// 	this.checkTagsEN.push(checkObject)
					// }

					// this.tagListResourceDE = this.tagListDE;
					// for (let i = 0; i < this.tagListResourceDE.length; i++) {
					// 	let checkObject: any = {};
					// 	checkObject.check = false;
					// 	checkObject.rid = this.tagListResourceDE[i].rid;

					// 	let foundObj = this.templateDataResource.tags.find(s => s.rid == checkObject.rid);
					// 	if (foundObj != null)
					// 		checkObject.check = true;
					// 	this.checkTagsDE.push(checkObject)
					// }

					// let a = this.checkTagsRO.find(t => !t.check);
					// let isAllChecked = (a === undefined);

					// let b = this.checkTagsEN.find(t => !t.check);
					// let isAllChecked2 = (b === undefined);

					// if (isAllChecked) {
					// 	this.noneSelected = false;
					// } else {
					// 	this.noneSelected = true;
					// }
				},
				error => this.errorMessage = <any>error);
	}

	checkAll() {
		this.templateDataResource.cinema = true;
		this.templateDataResource.news = true;
		this.noneSelected = false;
		// this.inputCategories = false;
	}

	uncheckAll() {
		this.templateDataResource.cinema = false;
		this.templateDataResource.news = false;
		this.noneSelected = true;
	}

	// check() {
	// 	if (this.templateDataResource.news) {
	// 		this.noneSelected = false;
	// 		this.inputCategories = false;
	// 	} else {
	// 		this.noneSelected = true;
	// 	}
	// }
	public addForm = new FormGroup({
		nameRo: new FormControl("nameRo", [Validators.required, Validators.maxLength(100), Validators.minLength(3), Validators.pattern('^[À-ža-z0-9A-Z ]+[À-ža-z0-9A-Z]')]),
		nameFr: new FormControl("nameFr", [Validators.maxLength(100), Validators.pattern('^[À-ža-z0-9A-Z ]+[À-ža-z0-9A-Z]')]),
		nameEn: new FormControl("nameEn", [Validators.maxLength(100), Validators.pattern('^[À-ža-z0-9A-Z ]+[À-ža-z0-9A-Z]')]),
		nameDe: new FormControl("nameDe", [Validators.maxLength(100), Validators.pattern('^[À-ža-z0-9A-Z ]+[À-ža-z0-9A-Z]')]),
	});



	newTemplate() {
		let semafor = false;

		if (this.templateDataResource.nameRo === null || this.templateDataResource.nameRo === "" || this.templateDataResource.nameRo === undefined) {
			this.templateDataResource.newHtmlFlags.inputErrorTitleRO = true;
			semafor = true;
		}
		// if (this.templateDataResource.nameFr === null || this.templateDataResource.nameFr === "" || this.templateDataResource.nameFr === undefined) {
		// 	this.templateDataResource.newHtmlFlags.inputErrorTitleFR = true;
		// 	semafor = true;
		// }
		// if (this.templateDataResource.nameEn === null || this.templateDataResource.nameEn === "" || this.templateDataResource.nameEn === undefined) {
		// 	this.templateDataResource.newHtmlFlags.inputErrorTitleEN = true;
		// 	semafor = true;
		// }
		// if (this.templateDataResource.nameDe === null || this.templateDataResource.nameDe === "" || this.templateDataResource.nameDe === undefined) {
		// 	this.templateDataResource.newHtmlFlags.inputErrorTitleDE = true;
		// 	semafor = true;
		// }
		// if (!this.templateDataResource.news) {
		// 	// this.inputCategories = true;
		// 	semafor = true;
		// }

		if (!this.addForm.valid || semafor) {
			this.saveErrors = true;
			observableForkJoin(
				this.translate.get('Mising fields'),
				this.translate.get('Please fill out the fields!')
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			})
			//this._notificationService.create("Mising fields", 'Please fill out the fields!', 'error')
			return
		}

		// if (semafor == true) {
		// 	Observable.forkJoin(
		// 		this.translate.get('Mising fields'),
		// 		this.translate.get('Please fill out the fields!')
		// 	).subscribe((res) => {
		// 		this._notificationService.create(res[0], res[1], 'error')
		// 	})
		// 	//this._notificationService.create("Mising fields", 'Please fill out the fields!', 'error')
		// 	return
		// }

		//let str = .valueOf();
		//let metadata = JSON.parse(this.templateDataResource.metadata);
		// console.log("Eddd: ",this.templateDataResource.metadata);
		// let metadata = JSON.parse(this.templateDataResource.metadata);
		// console.log("Eddd22: ",metadata);

		this.templateDataResource.userEmail = this.userEmail;
		this.addNewsletterService.saveNewsletter('/templateEditor/saveN', this.templateDataResource)
			.subscribe(
				response => {
					console.log('succes.POST save  newsletter', response);
					this.templateDataResource = response;
					this.templateDataResource.newHtmlFlags = new NewHtmlFlags();
					localStorage.setItem('templateIdAdd', String(this.templateDataResource.rid));
					//window.open('/assets/mosaico/mosaico.html', '_self');

					if (this.templateDataResource.metadata === null || this.templateDataResource.metadata === "" || this.templateDataResource.metadata === undefined) {
						window.open('/assets/mosaico/mosaico.html', '_self');
						// this.addNewsletterService.saveNewsletter(this.templateDataResource)
						// 	.subscribe(
						// 	response => {
						// 		console.log('succes.POST save  newsletter', response);
						// 		this.templateDataResource = response;
						// 		this.templateDataResource.newHtmlFlags = new NewHtmlFlags();
						// 		localStorage.setItem('templateIdAdd', String(this.templateDataResource.rid));
						// 		window.open('/assets/mosaico/mosaico.html', '_self');
						// 	},
						// 	error => this.errorMessage = <any>error);
					} else {
						let metadata = JSON.parse(this.templateDataResource.metadata);
						localStorage.setItem('templateIdAdd', String(this.templateDataResource.rid));
						localStorage.setItem('metadata-' + metadata.key, this.templateDataResource.metadata);
						localStorage.setItem('template-' + metadata.key, this.templateDataResource.template);
						window.open('/assets/mosaico/editor.html#' + metadata.key, '_self');

					}
				},
				error => this.errorMessage = <any>error);


	}

	addNewsletter() {

		let semafor = false;

		if (this.templateDataResource.nameRo === null || this.templateDataResource.nameRo === "" || this.templateDataResource.nameRo === undefined) {
			this.templateDataResource.newHtmlFlags.inputErrorTitleRO = true;
			semafor = true;
		} else {
			this.templateDataResource.newHtmlFlags.inputErrorTitleRO = false;
		}
		// if (this.templateDataResource.nameFr === null || this.templateDataResource.nameFr === "" || this.templateDataResource.nameFr === undefined) {
		// 	this.templateDataResource.newHtmlFlags.inputErrorTitleFR = true;
		// 	semafor = true;
		// } else {
		// 	this.templateDataResource.newHtmlFlags.inputErrorTitleFR = false;
		// }
		// if (this.templateDataResource.nameEn === null || this.templateDataResource.nameEn === "" || this.templateDataResource.nameEn === undefined) {
		// 	this.templateDataResource.newHtmlFlags.inputErrorTitleEN = true;
		// 	semafor = true;
		// } else {
		// 	this.templateDataResource.newHtmlFlags.inputErrorTitleEN = false;
		// }
		// if (this.templateDataResource.nameDe === null || this.templateDataResource.nameDe === "" || this.templateDataResource.nameDe === undefined) {
		// 	this.templateDataResource.newHtmlFlags.inputErrorTitleDE = true;
		// 	semafor = true;
		// } else {
		// 	this.templateDataResource.newHtmlFlags.inputErrorTitleDE = false;
		// }
		// if (!this.templateDataResource.news) {
		// 	this.inputCategories = true;
		// 	semafor = true;
		// }
		if (this.templateDataResource.template == "" || this.templateDataResource.template == undefined && this.templateDataResource.template == null) {
			this.inputMosaico = true
			semafor = true;
		}

		// if (this.templateDataResource.tags.length == 0) {
		// 	this.errorTags = true;
		// 	return;
		// }

		if (!this.addForm.valid || semafor) {
			this.saveErrors = true;
			observableForkJoin(
				this.translate.get('Mising fields'),
				this.translate.get('Please fill out the fields!')
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			})
			//this._notificationService.create("Mising fields", 'Please fill out the fields!', 'error')
			return
		}

		// if (semafor == true) {
		// 	Observable.forkJoin(
		// 		this.translate.get('Mising fields'),
		// 		this.translate.get('Please fill out the fields!')
		// 	).subscribe((res) => {
		// 		this._notificationService.create(res[0], res[1], 'error')
		// 	})
		// 	//this._notificationService.create("Mising fields", 'Please fill out the fields!', 'error')
		// 	return
		// }
		this.templateDataResource.userEmail = this.userEmail;
		this.addNewsletterService.saveNewsletter('/templateEditor/saveN', this.templateDataResource)
			.subscribe(
				response => {
					console.log('succes.POST save  newsletter add', response);
					observableForkJoin(
						this.translate.get('Success'),
						this.translate.get('Newsletter has been successfully added!')
					).subscribe((res) => {
						this._notificationService.create(res[0], res[1], 'success')
					})
					//this._notificationService.create("Success", 'Newsletter has been successfully added!', 'success')
					if (this.files != undefined) {
						this.uploadFiles(/* this.files */);
					}
					localStorage.removeItem('templateIdAdd');
					localStorage.setItem('templateCreatedAdd', "false");
					this.router.navigateByUrl('/newsletter-list');
				},
				error => {
					this.errorMessage = <any>error
					observableForkJoin(
						this.translate.get('Error'),
						this.translate.get('Newsletter could not be added!')
					).subscribe((res) => {
						this._notificationService.create(res[0], res[1], 'error')
					})
					//this._notificationService.create("Error", 'Newsletter could not be added!', 'error')
				}
			);
	}


	changeListenerDOC($event): void {
		this.files = $event.target.files;
	}

	checkDocument(document: ContentCommonFileResource) {
		for (let i = 0; i < this.emptyArray.mTemplateDataFileList.length; i++) {
			if (document.rid == this.emptyArray.mTemplateDataFileList[i].rid) {
				return true;
			}
		}
		return false;
	}

	updateCheckedOptions(document: ContentCommonFileResource, event) {
		if (event.target.checked) {
			this.emptyArray.mTemplateDataFileList.push(document);
		} else {
			var index = this.emptyArray.mTemplateDataFileList.indexOf(document);
			this.emptyArray.mTemplateDataFileList.splice(index, 1);
		}
		console.log("eveniment : {}, document : {}", event.target.checked, document);
	}

	delDoc(value) {
		value.deleteDocBool = true;
	}


	uploadFiles(/* rid: number,  files*/) {
		let errorFiles: string[] = []
		for (let i = 0; i < this.files.length; i++) {
			this.formDataDoc = new FormData()
			var fileDoc: File = this.files[i];
			this.formDataDoc.append('file', fileDoc, fileDoc.name)
			this.addNewsletterService.uploadDoc(`/templateEditor/uploadNewsletterFiles?newsletterId=${this.templateDataResource.rid}`, this.formDataDoc)
				.subscribe(
					pdf => {
						this.formDataDoc = null;
						this.files = [];
						this.getDocuments();
						if (errorFiles.length > 0 && i == this.files.length - 1) {
							observableForkJoin(
								this.translate.get('File size must be less than 30 MB!'),
								this.translate.get('Files size must be less than 30 MB!')
							).subscribe((res) => {
								let errorFilesString: string = "";
								for (let x = 0; x < errorFiles.length; x++) {
									errorFilesString = errorFilesString + errorFiles[x] + ", ";
								}
								if (errorFiles.length == 1) {
									this._notificationService.create(res[0], errorFilesString, 'error')
								} else {
									this._notificationService.create(res[1], errorFilesString, 'error')
								}
							})
						}
					},
					error => {
						console.error(error)
						if (errorFiles != null && errorFiles != undefined) {
							if (errorFiles.indexOf(this.files[i].name) == -1) {
								errorFiles.push(this.files[i].name);
							}
						} else {
							errorFiles.push(this.files[i].name);
						}
						if (errorFiles.length > 0 && i == this.files.length - 1) {
							observableForkJoin(
								this.translate.get('File size must be less than 30 MB!'),
								this.translate.get('Files size must be less than 30 MB!')
							).subscribe((res) => {
								let errorFilesString: string = "";
								for (let x = 0; x < errorFiles.length; x++) {
									errorFilesString = errorFilesString + errorFiles[x] + ", ";
								}
								if (errorFiles.length == 1) {
									this._notificationService.create(res[0], errorFilesString, 'error')
								} else {
									this._notificationService.create(res[1], errorFilesString, 'error')
								}
							})
						}
					})

		}
	}

	removeFile(index) {
		var filesBuffer = [];
		Array.prototype.push.apply(filesBuffer, this.files);
		for (let i = 0; i < filesBuffer.length; i++) {
			if (i == index) {
				filesBuffer.splice(i, 1)
			}
		}
		this.files= [];
		this.files=filesBuffer;
	}

	getDocuments() {
		this.addNewsletterService.getDocumentList(`/templateEditor/getNewsletterFiles?newsletterId=${this.addressParams.newsletterRid}`)
			.subscribe(
				content => {
					this.documentList = content;
					console.log("fisierele mele", this.documentList)
					this.emptyArray.mTemplateDataFileList = [];
					if (this.documentList.mTemplateDataFileList != null) {
						this.showDocuments = true;
					} else {
						this.showDocuments = false;
					}
				},
				error => console.error(error))
	}

	deleteDoc(rid: number) {
		this.addNewsletterService.deleteDoc(`/templateEditor/deleteNewsletterFile/` + rid)
			.subscribe(
				d => {
					this.emptyArray.mTemplateDataFileList = [];
					this.getDocuments()
				},
				error => console.error(error))
	}

	checkAllDocs() {
		this.emptyArray.mTemplateDataFileList = Object.assign([], this.documentList.mTemplateDataFileList);

	}

	uncheckAllDocs() {
		this.emptyArray.mTemplateDataFileList = [];
	}

	deleteAll() {
		this.addNewsletterService.multipleDeleteDocuments(`/templateEditor/deleteNewsletterFileList`, this.emptyArray)
			.subscribe(
				body => {
					this.getDocuments();
					this.emptyArray.mTemplateDataFileList = [];
					this.showConfirmation = false;
				},
				error => console.error(error))
	}
}



